import DispatchConstants from '../../constants/DispatchConstants';

const initState = () => ({
    properties: [],
    propertiesByAlias: {},
    unitsByFloorplanName: {},
});

const marketPropertiesSelect = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_MARKET_PROPERTIES_SELECT_GET_SUCCESS:
            return {
                ...state,
                properties: payload.properties,
                propertiesByAlias: payload.properties.reduce((newObject, property) => {
                    newObject[property.listingAlias] = property;
                    return newObject;
                }, {}),
            };
        case DispatchConstants.ANALYTICS_MARKET_UNITS_FOR_PROPERTY_GET_SUCCESS:
            return {
                ...state,
                unitsByFloorplanName: payload.unitsByFloorplanName,
            };
        default:
            return state;
    }
};

export default marketPropertiesSelect;
